import { jsx } from "react/jsx-runtime";
import { cva } from "@/styled-system/css";
import { Box } from "@zillow/constellation-10";
import React from "react";
import { resolveSpacing } from "../../utils/token-migration/migrate-responsive.esm.js";
const iframeRecipe = cva({
  base: {},
  variants: {
    marginBlockStart: {
      none: {
        marginBlockStart: "none"
      },
      tightest: {
        marginBlockStart: "tightest"
      },
      tighter: {
        marginBlockStart: "tighter"
      },
      tight: {
        marginBlockStart: "tight"
      },
      default: {
        marginBlockStart: "default"
      },
      loose: {
        marginBlockStart: "loose"
      },
      looser: {
        marginBlockStart: "looser"
      },
      "layout.tightest": {
        marginBlockStart: "layout.tightest"
      },
      "layout.tighter": {
        marginBlockStart: "layout.tighter"
      },
      "layout.tight": {
        marginBlockStart: "layout.tight"
      },
      "layout.default": {
        marginBlockStart: "layout.default"
      },
      "layout.loose": {
        marginBlockStart: "layout.loose"
      },
      "layout.looser": {
        marginBlockStart: "layout.looser"
      },
      "layout.loosest": {
        marginBlockStart: "layout.loosest"
      },
      "layout.vast.default": {
        marginBlockStart: "layout.vast.default"
      },
      "layout.vast.loose": {
        marginBlockStart: "layout.vast.loose"
      },
      "-tightest": {
        marginBlockStart: "-tightest"
      },
      "-tighter": {
        marginBlockStart: "-tighter"
      },
      "-tight": {
        marginBlockStart: "-tight"
      },
      "-default": {
        marginBlockStart: "-default"
      },
      "-loose": {
        marginBlockStart: "-loose"
      },
      "-looser": {
        marginBlockStart: "-looser"
      },
      "-layout.looser": {
        marginBlockStart: "-layout.looser"
      },
      "-layout.vast.default": {
        marginBlockStart: "-layout.vast.default"
      },
      "-layout.vast.loose": {
        marginBlockStart: "-layout.vast.loose"
      }
    },
    marginBlockEnd: {
      none: {
        marginBlockEnd: "none"
      },
      tightest: {
        marginBlockEnd: "tightest"
      },
      tighter: {
        marginBlockEnd: "tighter"
      },
      tight: {
        marginBlockEnd: "tight"
      },
      default: {
        marginBlockEnd: "default"
      },
      loose: {
        marginBlockEnd: "loose"
      },
      looser: {
        marginBlockEnd: "looser"
      },
      "layout.tightest": {
        marginBlockEnd: "layout.tightest"
      },
      "layout.tighter": {
        marginBlockEnd: "layout.tighter"
      },
      "layout.tight": {
        marginBlockEnd: "layout.tight"
      },
      "layout.default": {
        marginBlockEnd: "layout.default"
      },
      "layout.loose": {
        marginBlockEnd: "layout.loose"
      },
      "layout.looser": {
        marginBlockEnd: "layout.looser"
      },
      "layout.loosest": {
        marginBlockEnd: "layout.loosest"
      },
      "layout.vast.default": {
        marginBlockEnd: "layout.vast.default"
      },
      "layout.vast.loose": {
        marginBlockEnd: "layout.vast.loose"
      },
      "-tightest": {
        marginBlockEnd: "-tightest"
      },
      "-tighter": {
        marginBlockEnd: "-tighter"
      },
      "-tight": {
        marginBlockEnd: "-tight"
      },
      "-default": {
        marginBlockEnd: "-default"
      },
      "-loose": {
        marginBlockEnd: "-loose"
      },
      "-looser": {
        marginBlockEnd: "-looser"
      },
      "-layout.looser": {
        marginBlockEnd: "-layout.looser"
      },
      "-layout.vast.default": {
        marginBlockEnd: "-layout.vast.default"
      },
      "-layout.vast.loose": {
        marginBlockEnd: "-layout.vast.loose"
      }
    },
    marginInlineStart: {
      none: {
        marginInlineStart: "none"
      },
      tightest: {
        marginInlineStart: "tightest"
      },
      tighter: {
        marginInlineStart: "tighter"
      },
      tight: {
        marginInlineStart: "tight"
      },
      default: {
        marginInlineStart: "default"
      },
      loose: {
        marginInlineStart: "loose"
      },
      looser: {
        marginInlineStart: "looser"
      },
      "layout.tightest": {
        marginInlineStart: "layout.tightest"
      },
      "layout.tighter": {
        marginInlineStart: "layout.tighter"
      },
      "layout.tight": {
        marginInlineStart: "layout.tight"
      },
      "layout.default": {
        marginInlineStart: "layout.default"
      },
      "layout.loose": {
        marginInlineStart: "layout.loose"
      },
      "layout.looser": {
        marginInlineStart: "layout.looser"
      },
      "layout.loosest": {
        marginInlineStart: "layout.loosest"
      },
      "layout.vast.default": {
        marginInlineStart: "layout.vast.default"
      },
      "layout.vast.loose": {
        marginInlineStart: "layout.vast.loose"
      },
      "-tightest": {
        marginInlineStart: "-tightest"
      },
      "-tighter": {
        marginInlineStart: "-tighter"
      },
      "-tight": {
        marginInlineStart: "-tight"
      },
      "-default": {
        marginInlineStart: "-default"
      },
      "-loose": {
        marginInlineStart: "-loose"
      },
      "-looser": {
        marginInlineStart: "-looser"
      },
      "-layout.looser": {
        marginInlineStart: "-layout.looser"
      },
      "-layout.vast.default": {
        marginInlineStart: "-layout.vast.default"
      },
      "-layout.vast.loose": {
        marginInlineStart: "-layout.vast.loose"
      }
    },
    marginInlineEnd: {
      none: {
        marginInlineEnd: "none"
      },
      tightest: {
        marginInlineEnd: "tightest"
      },
      tighter: {
        marginInlineEnd: "tighter"
      },
      tight: {
        marginInlineEnd: "tight"
      },
      default: {
        marginInlineEnd: "default"
      },
      loose: {
        marginInlineEnd: "loose"
      },
      looser: {
        marginInlineEnd: "looser"
      },
      "layout.tightest": {
        marginInlineEnd: "layout.tightest"
      },
      "layout.tighter": {
        marginInlineEnd: "layout.tighter"
      },
      "layout.tight": {
        marginInlineEnd: "layout.tight"
      },
      "layout.default": {
        marginInlineEnd: "layout.default"
      },
      "layout.loose": {
        marginInlineEnd: "layout.loose"
      },
      "layout.looser": {
        marginInlineEnd: "layout.looser"
      },
      "layout.loosest": {
        marginInlineEnd: "layout.loosest"
      },
      "layout.vast.default": {
        marginInlineEnd: "layout.vast.default"
      },
      "layout.vast.loose": {
        marginInlineEnd: "layout.vast.loose"
      },
      "-tightest": {
        marginInlineEnd: "-tightest"
      },
      "-tighter": {
        marginInlineEnd: "-tighter"
      },
      "-tight": {
        marginInlineEnd: "-tight"
      },
      "-default": {
        marginInlineEnd: "-default"
      },
      "-loose": {
        marginInlineEnd: "-loose"
      },
      "-looser": {
        marginInlineEnd: "-looser"
      },
      "-layout.looser": {
        marginInlineEnd: "-layout.looser"
      },
      "-layout.vast.default": {
        marginInlineEnd: "-layout.vast.default"
      },
      "-layout.vast.loose": {
        marginInlineEnd: "-layout.vast.loose"
      }
    }
  }
});
function collectSpacing({
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  margin
}) {
  const result = {
    marginTop,
    marginBottom,
    marginLeft,
    marginRight
  };
  if (margin && typeof margin === "object") {
    Object.entries(margin).forEach(([key, value]) => {
      if (value && !result[key]) {
        result[key] = value;
      }
    });
  }
  return result;
}
function buildMarginProps(spacing) {
  const recipeProps = {};
  const responsiveCss = {};
  const mappings = [["marginTop", "marginBlockStart"], ["marginBottom", "marginBlockEnd"], ["marginLeft", "marginInlineStart"], ["marginRight", "marginInlineEnd"]];
  mappings.forEach(([v8Key, v10Key]) => {
    const resolved = resolveSpacing(spacing[v8Key]);
    if (typeof resolved === "string") {
      recipeProps[v10Key] = resolved;
    } else if (resolved) {
      responsiveCss[v10Key] = resolved;
    }
  });
  return {
    recipeProps,
    responsiveCss
  };
}
const ResponsiveIframe = React.forwardRef(function ResponsiveIframe2({
  width,
  height,
  margin,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  ...rest
}, ref) {
  const spacing = collectSpacing({
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    margin
  });
  const {
    recipeProps,
    responsiveCss
  } = buildMarginProps(spacing);
  const inlineStyle = {
    aspectRatio: `${width} / ${height}`,
    width: `${width}px`,
    maxWidth: "100%",
    height: "100%"
  };
  return /* @__PURE__ */ jsx(Box, { asChild: true, css: {
    ...iframeRecipe.raw(recipeProps),
    ...responsiveCss
  }, children: /* @__PURE__ */ jsx("iframe", { ref, style: inlineStyle, ...rest }) });
});
export {
  buildMarginProps,
  collectSpacing,
  ResponsiveIframe as default
};
